import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faTachometer, faEye, faPencil, faTrashCan, faPlus, faTable, faArrowRight, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { getCMSImageListAPI, deleteCMSImageAPI } from "../../API/CMSImage";
import { useRecoilState } from 'recoil';

import FormErrorBox from "../Reusable/FormErrorBox";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { topAlertMessageState, topAlertStatusState } from "../../AppState";


function PickCMSImageModal({ isVisible, setIsVisible, onClick }) {

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [images, setImages] = useState("");
    const [selectedImageForDeletion, setSelectedImageForDeletion] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onImageListSuccess(response){
        console.log("onImageListSuccess: Starting...");
        setImages(response);
    }

    function onImageListError(apiErr) {
        console.log("onImageListError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onImageListDone() {
        console.log("onImageListDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const fetchList = () => {
        setFetching(true);
        getCMSImageListAPI(
            onImageListSuccess,
            onImageListError,
            onImageListDone
        );
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            fetchList();
        }

        return () => { mounted = false; }
    }, []);

    ////
    //// Component rendering.
    ////

    // Render the JSX content.
    return (
        <>
            {isVisible && <>
                <div class="modal is-active">
                    <div class="modal-background"></div>
                    <div class="modal-card">
                        <header class="modal-card-head">
                            <p class="modal-card-title">Modal title</p>
                            <button class="delete" aria-label="close" onClick={(e)=>setIsVisible(false)}></button>
                        </header>
                        <section class="modal-card-body">
                            <FormErrorBox errors={errors} />

                            {isFetching
                                ? <>
                                    <PageLoadingContent displayMessage={"Please wait"} />
                                </>
                                : <>
                                    {images && images.length > 0
                                        ?
                                        <div class="container">
                                            <div class="columns is-multiline">
                                            {images && images.map(function(image, i){
                                                return <div class="column is-one-third" key={image.id}>
                                                    <div class="card">
                                                        <div class="card-image p-3">
                                                            <figure class="image is-4by3">
                                                                <img src={image.publicObjectUrl} alt="Placeholder image" />
                                                            </figure>
                                                        </div>
                                                        <header class="card-header">
                                                            <p class="card-header-title">
                                                                <Link to={`/cms-image/${image.id}`} target="_blank" rel="noreferrer">
                                                                    {image.name}&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} />
                                                                </Link>
                                                            </p>
                                                            <button class="card-header-icon" aria-label="more options">
                                                              <span class="icon">
                                                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                                                              </span>
                                                            </button>
                                                        </header>
                                                        {/*<div class="card-content">
                                                            <div class="content">
                                                                {image.description}
                                                            </div>
                                                        </div>*/}
                                                        <footer class="card-footer">
                                                            <a onClick={(e,img)=>onClick(image)} class="card-footer-item">
                                                                Pick&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} />
                                                            </a>
                                                        </footer>
                                                    </div>
                                                </div>;
                                                })}
                                            </div>
                                        </div>
                                        :
                                        <section class="hero is-medium has-background-white-ter">
                                          <div class="hero-body">
                                            <p class="title">
                                                <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No Images
                                            </p>
                                            <p class="subtitle">
                                                No images. <b><Link to="/cms-images/add">Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started uploading your first image.
                                            </p>
                                          </div>
                                        </section>
                                    }
                                </>
                            }
                        </section>
                        <footer class="modal-card-foot">
                            {/* <button class="button is-success" onClick={(e)=>setIsVisible(false)}>Save changes</button> */}
                            <button class="button" onClick={(e)=>setIsVisible(false)}>Cancel</button>
                        </footer>
                    </div>
                </div>
            </>}
        </>
    )
}

export default PickCMSImageModal;
